import { ButtonWidget,MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { showAddAdGroupDialog } from '../groups/services/actions/ActiveDirectoryGroupAction';
import { showCreateGroupDialog } from '../groups/services/actions/CreateGroupDialogAction';
import { AddContentButton } from './AddContentButton';


export interface AddGroupsButtonProps {
  readonly buttonText: string;
  readonly canSessionUserManageUsers: boolean;
}

export enum AddGroupDialogType {
  AddLocalGroup = 'addLocalGroup',
  AddADGroup = 'addADGroup'
}

const ADD_GROUPS_TEST_ID = 'action-add-groups';

function createAddGroupsMenuItemOptions(): MenuItemInfo[] {
  let menuItemInfos: MenuItemInfo[] = [];
  menuItemInfos.push({displayValue: Messages.addGroupsLocalGroupButton(), value: AddGroupDialogType.AddLocalGroup});

  if (ServerSettingsUnauthenticated.isServerDomainFamilyActiveDirectory()) {
    menuItemInfos.push({displayValue: Messages.addUsersImportAdGroupButton(), value: AddGroupDialogType.AddADGroup});
  }

  return menuItemInfos;
}

const onSelectUserOption = async (addGroupDialogType: AddGroupDialogType): Promise<void> => {
  switch (addGroupDialogType) {
    case AddGroupDialogType.AddLocalGroup:
      showCreateGroupDialog();
      break;
    case AddGroupDialogType.AddADGroup:
      showAddAdGroupDialog();
      break;
    default:
      return;
  }
};

export const AddGroupsButton: React.FunctionComponent<AddGroupsButtonProps> = props => {
  return(<div>
    {props.canSessionUserManageUsers &&
    <AddContentButton
      buttonText={props.buttonText}
      testId={ADD_GROUPS_TEST_ID}
      menuItems={createAddGroupsMenuItemOptions()}
      onSelect={onSelectUserOption}
    />}
    {!props.canSessionUserManageUsers &&
    <ButtonWidget
      testId={ADD_GROUPS_TEST_ID}
      handleClick={() => onSelectUserOption(AddGroupDialogType.AddLocalGroup)}
    > {props.buttonText} </ButtonWidget>}
  </div>);
};
